export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_CONTROLS = "AUTH_CONTROLS";
export const SET_USER = "SET_USER";
export const ACCOUNT_CONTROLS = "ACCOUNT_CONTROLS";
export const FETCH_SIDEBAR_CATEGORY = "FETCH_SIDEBAR_CATEGORY";
export const SIDEBAR_CATEGORY_LOADING = "SIDEBAR_CATEGORY_LOADING";

export const FETCH_CAROUSEL_DATA = "FETCH_CAROUSEL_DATA";

export const FETCH_HOMEPRODUCTS = "FETCH_HOMEPRODUCTS";
export const HOMEPRODUCTS_LOADING = "HOMEPRODUCTS_LOADING";

export const FETCH_BANNER = "FETCH_BANNER";
export const FETCH_CLIENTS = "FETCH_CLIENTS";

export const UPDATE_CATEGORYNAME = "UPDATE_CATEGORY_NAME";
export const UPDATE_CATEGORYTYPE = "UPDATE_CATEGORY_TYPE";

export const FETCH_WORKOUT_PLANS = "FETCH_WORKOUT_PLANS";
export const ADD_WORKOUT_PLAN = "ADD_WORKOUT_PLAN";
export const DELETE_WORKOUT_PLAN = "DELETE_WORKOUT_PLAN";
export const UPDATE_WORKOUT_PLAN = "UPDATE_WORKOUT_PLAN";
export const WORKOUT_CONTROLS = "WORKOUT_CONTROLS";

export const HOME_SECTION_CONTROLS = "HOME_SECTION_CONTROLS";

export const FETCH_COLLECTION = "FETCH_COLLECTION";
export const ADD_COLLECTION = "ADD_COLLECTION";
export const DELETE_COLLECTION = "DELETE_COLLECTION";
export const UPDATE_COLLECTION = "UPDATE_COLLECTION";
export const COLLECTION_CONTROLS = "COLLECTION_CONTROLS";

export const CART_PRODUCT_CONTROLS = "CART_PRODUCT_CONTROLS";
export const CART_ADDRESS_CONTROLS = "CART_ADDRESS_CONTROLS";
export const SET_CART_ORDER = "SET_CART_ORDER";

export const GET_ALL_ADDRESSES = "GET_ALL_ADDRESSES";
export const CREATE_NEW_ADDRESS = "CREATE_NEW_ADDRESS";
export const REMOVE_ADDRESS = "REMOVE_ADDRESS";
export const FETCH_ADDRESS = "FETCH_ADDRESS";

export const ADD_TO_WHISLIST = "ADD_TO_WHISLIST";
export const REMOVE_FROM_WHISLIST = "REMOVE_FROM_WHISLIST";
export const FETCH_WHISLIST = "FETCH_WHISLIST";

//Admin section starts
export const UTILITY_CONTROLS = "UTILITY_CONTROLS";
export const CATEGORIES_CONTROLS = "CATEGORIES_CONTROLS";
export const BRANDS_CONTROLS = "BRANDS_CONTROLS";
export const ATTRIBUTE_CONTROLS = "ATTRIBUTE_CONTROLS";
export const GALLERY_CONTROLS = "GALLERY_CONTROLS";
export const GENERAL_CONTROLS = "GENERAL_CONTROLS";
export const PRODUCT_CONTROLS = "PRODUCT_CONTROLS";
export const COUPON_CONTROLS = "COUPON_CONTROLS";
export const WORKOUTPLANS_CONTROLS = "WORKOUTPLANS_CONTROLS";
export const CAROUSEL_CONTROLS = "CAROUSEL_CONTROLS";
export const BANNER_CONTROLS = "BANNER_CONTROLS";
export const CLIENT_CONTROLS = "CLIENT_CONTROLS";
export const SET_COUPON = "SET_COUPON";
export const SHOP_CONTROLS = "SHOP_CONTROLS";

export const BOOKINGS_CONTROLS = "BOOKINGS_CONTROLS";
export const ORDERS_CONTROLS = "ORDERS_CONTROLS";
export const REVIEWS_CONTROLS = "REVIEWS_CONTROLS";

export const CATEGORY_PRODUCTS_CONTROLS = "CATEGORY_PRODUCTS_CONTROLS";

export const STOCK_CONTROLS = "STOCK_CONTROLS";
